/*************************************************/
/* COOKIES (UserCentrics via GTM)                */
/*************************************************/

export function cookies() {
    const cookiePlaceholderSelector = '.cookie-placeholder';
    const placeholders = Array.from(document.querySelectorAll(cookiePlaceholderSelector));

    window.RenewConsent = () => {
        const usercentrics = document.querySelector('#usercentrics-cmp-ui');
        if (usercentrics && usercentrics.shadowRoot) {
            const getConsentButton = usercentrics.shadowRoot.querySelector('#uc-privacy-button');

            if (getConsentButton && getConsentButton.offsetParent !== null) { 
                getConsentButton.click(); 
            }
        }
    };

    const SetPlaceholderDisplayState = (placeholder, displayState) => {
        if (placeholder) {
            placeholder.style.display = displayState;
        }
    };

    const GetConsentData = () => {
        if (!window.dataLayer) return { marketing: false, statistics: false, functional: false, essential: false };

        const consentData = [...window.dataLayer].reverse().find(item => item.event === "consent_status");

        if (!consentData || !consentData.ucCategory) {
            return { marketing: false, statistics: false, functional: false, essential: false };
        }

        return {
            marketing: Boolean(consentData.ucCategory.marketing),
            statistics: Boolean(consentData.ucCategory.statistics),
            functional: Boolean(consentData.ucCategory.functional),
            essential: Boolean(consentData.ucCategory.essential)
        };
    };

    const ApplyConsent = () => {
        const consentData = GetConsentData();

        document.querySelectorAll('[data-categories*="marketing"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.marketing ? 'none' : 'flex');
        });

        document.querySelectorAll('[data-categories*="statistics"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.statistics ? 'none' : 'flex');
        });

        document.querySelectorAll('[data-categories*="functional"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.functional ? 'none' : 'flex');
        });

        document.querySelectorAll('[data-categories*="essential"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.essential ? 'none' : 'flex');
        });
    };

    const WatchForConsentChanges = () => {
        // Listen for GTM consent changes dynamically
        const observer = new MutationObserver(() => ApplyConsent());
        observer.observe(document.body, { childList: true, subtree: true });
        
        // Listen for dataLayer changes related to UserCentrics
        const originalPush = window.dataLayer.push;
        window.dataLayer.push = function (...args) {
            originalPush.apply(window.dataLayer, args);
            if (args.some(item => item.event === "consent_status")) {
                ApplyConsent();
            }
        };
    };

    // ✅ Initialize placeholders and event listeners
    const init = () => {
        ApplyConsent();
        WatchForConsentChanges();

        placeholders.forEach(placeholder => {
            placeholder.addEventListener('click', event => {
                event.stopPropagation();
                RenewConsent();
            });
        });
    };

    init();
}
